// extracted by mini-css-extract-plugin
export default {"main":"styles_main__Cqjwr","circles":"styles_circles__Nd0T4","circles--bottom":"styles_circles--bottom__OzLlV"};